(function () {
  'use strict';

  const KEY = 'dc_recently_viewed';
  const MAX = 8;

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  }

  function saveList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); }
    catch {}
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isValidUrl(str) {
    return typeof str === 'string' && (str.startsWith('/') || str.startsWith('http'));
  }

  // Record current product page
  const meta = document.querySelector('[data-product-id]');
  if (meta) {
    const id    = meta.dataset.productId;
    const title = meta.dataset.productTitle || '';
    const url   = meta.dataset.productUrl   || window.location.pathname;
    const img   = meta.dataset.productImg   || '';
    const price = meta.dataset.productPrice || '';

    let list = getList().filter(p => p.id !== id);
    list.unshift({ id, title, url, img, price });
    if (list.length > MAX) list = list.slice(0, MAX);
    saveList(list);
  }

  // Build a card element safely without innerHTML
  function buildCard(p) {
    const a = document.createElement('a');
    a.href  = isValidUrl(p.url) ? p.url : '#';
    a.className = 'dc-rv-card';

    const imgWrap = document.createElement('div');
    imgWrap.className = 'dc-rv-card__img-wrap';

    if (p.img && isValidUrl(p.img)) {
      const img = document.createElement('img');
      img.src     = p.img;
      img.alt     = p.title;
      img.loading = 'lazy';
      img.onerror = function () { this.parentElement.style.display = 'none'; };
      imgWrap.appendChild(img);
    }

    const info = document.createElement('div');
    info.className = 'dc-rv-card__info';

    const name = document.createElement('span');
    name.className   = 'dc-rv-card__name';
    name.textContent = p.title;

    const priceEl = document.createElement('span');
    priceEl.className   = 'dc-rv-card__price';
    priceEl.textContent = p.price;

    info.appendChild(name);
    info.appendChild(priceEl);
    a.appendChild(imgWrap);
    a.appendChild(info);
    return a;
  }

  // Render recently viewed section
  function renderSection() {
    const container = document.getElementById('dc-rv-grid');
    if (!container) return;

    const currentId = document.querySelector('[data-product-id]')?.dataset?.productId;
    const list = getList()
      .filter(p => p.id !== currentId && p.title && p.url)
      .slice(0, 6);

    if (list.length < 2) {
      const section = container.closest('.dc-rv-section');
      if (section) section.style.display = 'none';
      return;
    }

    container.innerHTML = '';
    list.forEach(p => container.appendChild(buildCard(p)));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderSection);
  } else {
    renderSection();
  }
})();
